import _styled from "@emotion/styled-base";
import React from "react";


var FormFieldComponent = _styled("div", {
  target: "e19nomb00",
  label: "FormFieldComponent"
})("display:block;margin-bottom:", function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.md;
}, ";> p{margin-top:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.xxs;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Zvcm1GaWVsZC9Gb3JtRmllbGQuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdxQyIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Gb3JtRmllbGQvRm9ybUZpZWxkLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSBcIkBlbW90aW9uL3N0eWxlZFwiO1xuXG5jb25zdCBGb3JtRmllbGRDb21wb25lbnQgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBibG9jaztcbiAgbWFyZ2luLWJvdHRvbTogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zcGFjaW5ncy5tZH07XG4gID4gcCB7XG4gICAgbWFyZ2luLXRvcDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zcGFjaW5ncy54eHN9O1xuICB9XG5gO1xuXG5jb25zdCBGb3JtRmllbGQgPSBwcm9wcyA9PiA8Rm9ybUZpZWxkQ29tcG9uZW50IHsuLi5wcm9wc30gLz47XG5cbmV4cG9ydCBkZWZhdWx0IEZvcm1GaWVsZDtcbiJdfQ== */"));

var FormField = function FormField(props) {
  return React.createElement(FormFieldComponent, props);
};

export default FormField;